import { StationConnectionModel } from '../models/station-connection';

export class StationConnectionAdapter {
  static fromApi(data: any): StationConnectionModel {
    return {
      id: data.weatherStationId,
      weatherStationId: data.weatherStationId,
      weatherStationIdentifier: data.weatherStationIdentifier,
      weatherStationDescription: data.weatherStationDescription,
      weatherStationType: data.weatherStationType,
      lastDayData: data.lastDayData,
      lastHourData: data.lastHourData,
    };
  }
}
